<template lang="pug">
  v-navigation-drawer(
    app,
    dark,
    permanent,
    :mini-variant="mini",
    transition="slide-x-reverse-transition",
    width="220",
  )
    v-list.py-0
      div(v-for='item in items', :key='item.title')
        v-divider(v-if="item.isDivider")
        v-list-item.d-relative(
          v-else-if="hasPermission(item.permissions)",
          :to="item.to || null",
          :class="item.class",
          @click="logout(item.title)",
        )
          v-list-item-icon
            v-icon {{ item.icon }}
          v-list-item-content.ml-8.pl-2
            v-list-item-title
              span(v-if="item.title === 'profile'") {{ fullName }}
              span(v-else) {{ $t(`sideNav.${item.title}`) }}

    div.locale-selector
      div.locale-mini-display.d-flex.justify-center(v-if="mini")
        v-btn(
          fab,
          @click.prevent="setLocalMini",
        )
          span.text-uppercase {{ $i18n.locale }}
      v-btn-toggle(
        mandatory,
        v-else,
        v-model='locale',
      )
        v-btn(
          light,
          outlined,
          @click="setLocale('en')",
        ) EN
        v-btn(
          light,
          outlined,
          @click="setLocale('cn')",
        ) CN

</template>

<script>
import { roleManager, progressWrapper } from "@/config/mixins.js";

export default {
  mixins: [roleManager, progressWrapper],

  props: {
    mini: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      locale: null,
      items: [
        { isDivider: true },
        {
          title: "profile",
          to: { name: "editProfile" },
          icon: "fas fa-user-circle",
        },
        { isDivider: true },
        {
          title: "dashboard",
          to: { name: "dashboard" },
          icon: "fas fa-file-download",
          permissions: ["superadmin"],
        },
        {
          title: "shop",
          to: { name: "shops" },
          icon: "fas fa-store",
          permissions: ["superadmin"],
        },
        {
          title: "staff",
          to: { name: "staffs" },
          icon: "fas fa-user",
          permissions: ["superadmin"],
        },
        {
          title: "user",
          to: { name: "users" },
          icon: "fas fa-users",
        },
        {
          title: "media",
          to: { name: "medias" },
          icon: "fas fa-images",
          permissions: ["superadmin"],
        },
        {
          title: "systemSettings",
          to: { name: "medicalConditions" },
          icon: "fas fa-cog",
          permissions: ["superadmin"],
        },
        {
          title: "logs",
          to: { name: "logs" },
          icon: "fas fa-history",
          permissions: ["superadmin"],
        },
        { isDivider: true },
        {
          class: "logout",
          title: "logout",
          icon: "fas fa-sign-out-alt",
        },
        { isDivider: true },
      ],
    };
  },

  created() {
    this.locale = this.$i18n.locale;
  },

  computed: {
    fullName() {
      return `${this.authUser.first_name} ${this.authUser.last_name}` || "";
    },
  },

  methods: {
    setLocale(locale) {
      this.$root.$i18n.locale = locale;
    },

    setLocalMini() {
      const locales = Object.keys(this.$i18n.messages);
      const currentIndex = locales.indexOf(this.locale);
      let updatedLocale = locales[currentIndex + 1];

      if (currentIndex === locales.length - 1) {
        updatedLocale = locales[0];
      }

      this.locale = updatedLocale;
      this.$root.$i18n.locale = updatedLocale;
    },

    hasPermission(permission) {
      if (permission) {
        return permission.includes(this.authUser.role);
      }

      return true;
    },

    logout(title) {
      if (title === "logout") {
        this.$store
          .dispatch("auth/logout")
          .then(() => this.$router.push({ name: "login" }));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.v-list-item {
  padding: 0 13px;
}
.v-navigation-drawer {
  background: linear-gradient(
    180deg,
    rgba(47, 105, 71, 1) 10%,
    rgba(69, 154, 104, 1) 33%,
    rgba(47, 105, 71, 1) 62%
  );
  .v-list-item__icon {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: 0;
    width: 30px;

    .v-icon {
      margin: auto;
    }
  }
}

.v-list-item--active.logout {
  &::before {
    content: none;
  }
}

::v-deep.locale-selector {
  bottom: 0;
  margin-bottom: 16px;
  position: absolute;

  .locale-mini-display {
    width: 56px;
    .v-btn {
      display: flex;
      height: 36px;
      width: 36px;
      color: var(--v-primary-base);
      background-color: white !important;
      // border: 1px solid rgba(255, 255, 255, 0.12);
    }
  }

  .v-btn-toggle {
    padding-left: 12px;
    background: transparent !important;
    .v-btn {
      height: 36px !important;
      min-height: 36px !important;
    }

    .v-item--active {
      color: var(--v-primary-base);
      background: white;
    }

    .v-btn:not(.v-item--active) {
      color: white;
    }
  }
}
</style>
